import { render, staticRenderFns } from "./GroupListSelectionView.vue?vue&type=template&id=19da8f80&scoped=true&"
import script from "./GroupListSelectionView.vue?vue&type=script&lang=ts&"
export * from "./GroupListSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListSelectionView.vue?vue&type=style&index=0&id=19da8f80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da8f80",
  null
  
)

export default component.exports